export default function autocomplete({ variables, }) {
    return {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    "&[data-clear-indicator='always'] .MuiAutocomplete-clearIndicator": {
                        visibility: "visible",
                    },
                    "&[data-clear-indicator='hover'] .MuiAutocomplete-clearIndicator": {
                        visibility: "hidden",
                    },
                    "&[data-clear-indicator='hover']:hover .MuiAutocomplete-clearIndicator": {
                        visibility: "visible",
                    },
                    "& .MuiOutlinedInput-root": {
                        paddingTop: variables.spacing_02,
                        paddingBottom: variables.spacing_02,
                    },
                    "& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot": {
                        height: "auto",
                        minHeight: variables.component_height_medium,
                        rowGap: variables.spacing_02,
                    },
                    "& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot.MuiInputBase-sizeSmall": {
                        minHeight: variables.component_height_small,
                    },
                    "& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot.MuiInputBase-sizeLarge": {
                        minHeight: variables.component_height_large,
                    },
                    "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                        paddingTop: variables.spacing_01,
                        paddingBottom: variables.spacing_01,
                    },
                    "& .MuiInputBase-input.MuiAutocomplete-input": {
                        "&.MuiInput-input, &.MuiOutlinedInput-input": {
                            paddingTop: variables.spacing_01,
                            paddingBottom: variables.spacing_01,
                        },
                    },
                    "& .MuiAutocomplete-tag": {
                        height: 24,
                        borderRadius: variables.border_radius_small,
                        backgroundColor: variables.surface_selected,
                        marginTop: 0,
                        marginBottom: 0,
                    },
                    "& .MuiChip-root .MuiChip-label": {
                        paddingLeft: variables.spacing_03,
                        paddingRight: variables.spacing_03,
                    },
                    "& .MuiChip-root .MuiSvgIcon-root": {
                        color: variables.interactive,
                        fontSize: 16,
                        margin: "0 1px 0 -6px;",
                    },
                    "& .MuiChip-root .MuiSvgIcon-root:hover": {
                        color: variables.interactive_hover,
                        fontSize: 16,
                        margin: "0 1px 0 -6px;",
                    },
                },
                paper: {
                    border: `1px solid ${variables.border_subtle}`,
                    borderRadius: variables.border_radius_small,
                    backgroundImage: "none",
                },
                listbox: {
                    "&.visible-overflow > li": {
                        overflow: "visible",
                    },
                },
                option: {
                    "&.MuiAutocomplete-option": {
                        padding: `${variables.spacing_02} ${variables.spacing_05}`,
                    },
                    "&.MuiAutocomplete-option:hover": {
                        backgroundColor: variables.surface_selected_hover,
                    },
                    "&.MuiAutocomplete-option[aria-selected='true'], &.MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
                        backgroundColor: variables.surface_selected,
                        fontWeight: variables.font_weight_medium,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=autocomplete.js.map